<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="cog"/>
          {{ $t('title') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12">
        <div class="c-sorting">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
            <!-- col -->
          </div>
          <!-- row -->
        </div>
        <!-- c-sorting -->
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-5">{{ $t('label') }}</div>
            <div class="col-lg-5">{{ $t('value') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-5">
              <b class="c-smart-table__label">{{ $t('label') }}: </b>
              <div><span>{{ item.label }}</span><span class="badge badge-secondary ml-2">{{ item.key }}</span></div>
            </div>
            <div class="col-lg-5">
              <b class="c-smart-table__label">{{ $t('value') }}: </b>
              <div class="text-break" v-if="Number.isInteger(Number(item.value))">{{ item.value | numFormat }}</div>
              <div class="text-break" v-else>
                {{ item.value.length > 80 ? item.value.substring(0, 70) + '...' : item.value }}
              </div>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content"
                   v-if="options.find(o => o.key === item.key) && options.find(o => o.key === item.key).role.includes($store.state.user.role)">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button @click="update(item._id)" type="button"
                            class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <form-select :label="$t('label')" :model="formModel" attribute="label" :errors="formErrors"
                   :options="options.filter(o => !o.role || o.role.includes($store.state.user.role)).map(item => {return {value: item.label, text: item.label ? item.label : $t('chooseParameter')}})">
      </form-select>
      <form-input :label="$t('key')" :model="formModel" attribute="key" :errors="formErrors" readonly></form-input>
      <form-input :label="$t('value')" :model="formModel" attribute="value" :errors="formErrors"></form-input>
    </b-modal>
  </main>
</template>
<script>
import List from '../mixins/List';
import CRUD from "../mixins/CRUD";

export default {
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/etc',
      defaultFormModel: {
        key: '',
        label: ''
      },
      autoLoad: true,
      options: [
        {label: null, key: ''},
        {label: 'Phí tin nhắn ZNS', key: 'zns-fee', role: ['owner', "admin"]},
        {label: 'Phí tin nhắn Viber', key: 'viber-fee', role: ['owner', "admin"]},
        {label: 'Phí tin nhắn QC', key: 'sms-ads-fee', role: ['owner', "admin"]},
        {label: 'Phí tin nhắn CSKH', key: 'sms-care-fee', role: ['owner', "admin"]},
        {label: 'Phí gọi tự động', key: 'ai-fee', role: ['owner', "admin"]},
        {label: 'Giá sử dụng dịch vụ CDP/khách hàng/tháng', key: 'cdp-fee', role: ['owner', "admin"]},
        {label: 'Số lượng khách hàng bắt đầu tính phí gói CDP', key: 'cdp-limit', role: ['owner', "admin"]},
        {label: 'Thời gian duyệt hồ sơ (theo phút)', key: 'kyc-time', role: ['owner', "admin", "tech"]},
        {label: 'Giá gói cước thoại trọn gói', key: 'plan-fee', role: ['owner', "admin"]},
        {label: 'Số tiền được cộng khi giới thiệu khách mới', key: 'ref-amount', role: ['owner', "admin"]},
        {
          label: 'Số tiền khách mới được cộng khi tham gia từ link giới thiệu',
          key: 'ref-target',
          role: ['owner', "admin"]
        },
        {label: 'Số tiền nạp tối thiểu của khách được giới thiệu', key: 'ref-deposit', role: ['owner', "admin"]},
        {label: 'Tự động xuất hoá đơn', key: 'invoice-enabled', role: ['owner', "admin"]},
        {label: 'Phiên bản App IOS hiện tại', key: 'mobile-ios-version', role: ['owner', "admin", "tech"]},
        {label: 'Phiên bản App Android hiện tại', key: 'mobile-android-version', role: ['owner', "admin", "tech"]},
        {label: 'Giá dạy bot / 1000 ký tự', key: 'bot-train-fee', role: ['owner', "admin", "tech"]},
        {
          label: 'Giá câu hỏi và câu trả lời của bot / 1000 ký tự',
          key: 'bot-chat-fee',
          role: ['owner', "admin", "tech"]
        },
        {label: 'Giá speed to text GPT / phút', key: 'bot-speed-to-text-gpt-fee', role: ['owner', "admin"]},
        {label: 'Giá khôi phục file ghi âm', key: 'restore-fee', role: ['owner', "admin"]},
        {label: 'Zalo server', key: 'zalo-server', role: ['owner', "admin", "tech"]},
        // {label: 'Bật tính năng gọi video nội bộ', key: 'video-enabled', role: ['owner', "admin", "tech"]},
        // {label: 'Giá gói 1 CCU video/tháng', key: 'video-ccu-fee', role: ['owner', "admin", "tech"]},
        {label: 'Tính năng mua sắm', key: 'ecommerce', role: ['owner', "admin", "tech"]},
        {label: 'Giá nhân viên ảo / tháng', key: 'chatbot-fee', role: ['owner', "admin", "tech"]},
        {
          label: 'Mở tính năng: mua/xuất hoá đơn điện tử (VAT)',
          key: 'client-invoice',
          role: ['owner', "admin", "tech"]
        },
        {label: 'Bật thông báo', key: 'system-alert', role: ['owner', "admin", "tech"]},
      ]
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Parameter',
        label: 'Parameter label',
        key: "Key",
        value: "Value",
        chooseParameter: "Choose parameter"
      },
      vi: {
        title: 'Tham số',
        label: 'Tên tham số',
        key: "Mã",
        value: "Giá trị",
        chooseParameter: "Chọn tham số"
      }
    }
  },
  watch: {
    "formModel.label": function (val) {
      let option = this.options.find(item => item.label === val);
      if (option) {
        this.formModel.key = option.key;
      }
    }
  },
  methods: {}
}
</script>

<style>
select {
  max-width: 100% !important;
}
</style>